<!-- Se oculta entero dentro del flujo de Pronto Pago (pestaña 5) -->
<div class="banner-restitucion" *ngIf="viewBanneer && tabView_index != 5">
    <div class="titulo-banner">
      <app-text Theme="Heading2" Text="Ley Corta - Plan de Pago" style="color:#0078C8"></app-text>
    </div>
    <div class="aviso-periodo-maximo">
      <app-text Theme="BodyRegular" Text="Colmena restituirá en un plazo máximo de 10 años, menor a los 13 años fijados como máximo por Ley. " style="color:#ffffff"></app-text>
    </div>
    <div class="periodo-pago-restitucion-colmena">
      <img src="./assets/img/periodo-pago-restitucion-colmena.png?202412011229" />
    </div>
</div>

<div class="wrapper-notification">
    <p-toast></p-toast>
  </div>
<div id="home">
    <app-card class="box-wrapper-home" Theme="card-primary shadow background-white">
        <div card-content *ngIf="activeBreadCrumbs">
            <app-bread-crumb>
                <li rutas-bread>Consulta </li>
                <span rutas-bread class="separador-bread">
                  <img src="./assets/img/ico_arrow_breadcrumd.svg" />
                </span>
                <li rutas-bread class="activo-bread">Excedentes por Restitución</li>
            </app-bread-crumb>
        </div>
        
        <div class="box-wrapper-restitucion" card-content>
            <!-- Oferta de Pronto Pago: solo si se cumple la cadena de habilitacion completa -->
            <app-banner-pronto-pago
                *ngIf="mostrarBannerProntoPago && tabView_index != 5"
                [ContentBannerProntoPago]="contentBannerProntoPago"
                (abrir)="abrirProntoPago($event)">
            </app-banner-pronto-pago>

            <div *ngIf="viewTabMenuRestitucion">
                <app-tab-menu-restitucion (tabViewSelected)="getTabViewSelected($event)" [Theme]="themeTabMenu" [Items]=dataTabMenu>
                </app-tab-menu-restitucion>
            </div>
            <div >
                <app-tab-view Theme="tab-view-primitive">
                  <!-- BIFURCACION AFILIADOS/EXAFILIADOS-NOAFILIADOS -->
                  <div class="tabView" tab-view-content>
                    <ng-container *ngIf="tabView_index == 10">
                      <div>
                        <app-body Theme="body-normal">
                            <div body-content>
                                <div class="head-form">
                                    <!-- 
                                    <app-icon class="icon"
                                        [Path]="'assets/img/iconos/ico_ingresar-sucursal-virtual.svg'"></app-icon>
                                        -->
                                    <app-text Theme="Heading3" Text="Consulta Excedentes de Restitución por fallo."
                                        [RadiusLoading]="10" style="color:#0078C8;" *ngIf="activeHead"></app-text>
                                    <br/>
                                    
                                      <app-text Theme="BodyRegular" Text="{{textBienvenido}}"
                                        [RadiusLoading]="10" style="color:#757575;text-align: justify;"></app-text>
                                    
                                        <ng-container *ngIf="typeApp === '0'">
                                            <p class="link">Si quieres conocer más detalles sobre el fallo, <span (click)="goToLink()">haz click aqui</span></p>
                                        </ng-container>
                                       
                                </div>
                                <div class="box-bifurcacion-usuario">
                                     <div class="box-bifurcacion">
                                        <app-card Theme="card-primary shadow background-white">
                                            <div card-content>
                                                <app-body Theme="body-normal">
                                                    <div body-content>
                                                      <div class="imagen">
                                                        <img src="./assets/img/logo-colmena.svg">
                                                      </div>

                                                      <div class="body">
                                                        <app-text Theme="BodyRegular" Text="Accede a tu sucursal virtual para consultar si te corresponden restituciones por la Ley N°21.674" [RadiusLoading]="10" style="color:#757575;text-align: justify;"></app-text>
                                                      </div>

                                                      <div class="callToAction">
                                                        <p-button 
                                                          label="Sucursal virtual" 
                                                          [loading]="loading" 
                                                          (onClick)="ingresarUsuarioBifurcacion('afiliado')"
                                                          styleClass="btn-colmena"
                                                          />
                                                      </div>

                                                    </div>
                                                </app-body>
                                            </div>
                                        </app-card>
                                     </div>
                                     <div class="no-afilado">
                                      <app-card Theme="card-primary shadow background-white">
                                        <div card-content>
                                            <app-body Theme="body-normal">
                                                <div body-content>
                                                  <div class="imagen inline-text">
                                                    <!-- <img src="./assets/img/ico_error.svg"> -->
                                                    <app-text Theme="Heading3" Text="Ex Afiliados"
                                                      [RadiusLoading]="10" style="color:#0078C8;" *ngIf="activeHead"></app-text>
                                                  </div>

                                                  <div class="body">
                                                    <app-text Theme="BodyRegular" Text="Si eres ex afiliado Colmena, consulta aquí si te corresponden restituciones por Ley N° 21.674." [RadiusLoading]="10" style="color:#757575;text-align: justify;"></app-text>
                                                  </div>

                                                  <div class="callToAction">
                                                    <p-button 
                                                      label="Consultar" 
                                                      [loading]="loading" 
                                                      (onClick)="ingresarUsuarioBifurcacion('no-afiliado')"
                                                      styleClass="btn-colmena"
                                                      />
                                                  </div>

                                                </div>
                                            </app-body>
                                        </div>
                                    </app-card>
                                     </div>
                                    

                                </div>
                            </div>
                        </app-body>
                      </div>
                    </ng-container>
                  </div>

                    <!-- LOGIN VALIDACION EQUIFAX -->
                    <div class="tabView" tab-view-content>
                      <ng-container *ngIf="tabView_index == 0">
                        <div>
                          <app-body Theme="body-normal">
                              <div body-content>
                                  <div class="head-form">
                                      <!-- 
                                      <app-icon class="icon"
                                          [Path]="'assets/img/iconos/ico_ingresar-sucursal-virtual.svg'"></app-icon>
                                          -->
                                      <app-text Theme="Heading3" Text="Consulta Excedentes de Restitución por fallo."
                                          [RadiusLoading]="10" style="color:#0078C8;" *ngIf="activeHead"></app-text>
                                      <br/>
                                          <app-text Theme="BodyRegular" Text="{{textBienvenido}}"
                                          [RadiusLoading]="10" style="color:#757575;"></app-text>
                                      
                                          <ng-container *ngIf="typeApp === '0'">
                                              <p class="link">Si quieres conocer más detalles sobre el fallo, <span (click)="goToLink()">haz click aqui</span></p>
                                          </ng-container>
                                         
                                  </div>
                                  <div class="box-restitucion">
                                       <div class="box-form">
                                          <app-card Theme="card-primary shadow background-white">
                                              <div card-content>
                                                  <app-body Theme="body-normal">
                                                      <div body-content>
                                                          <form [formGroup]="formData">
                                                              <div class="box-campo-input">
                                                                  <app-text Theme="CaptionRegular" Text="RUT:" [RadiusLoading]="10" style="color:#0078C8;"></app-text>                                                            
                                                                  <input [pKeyFilter]="filterRut" class="inputt" type="text" formControlName="username" placeholder="00000000-0" (input)="onRutInput($event)" [ngClass]="{'is-invalid': submitted && f['username'].errors}" maxlength="10" pKeyFilter="alphanum" (blur)="verifyRut()" />
                                                                  <div class="error">
                                                                      <div *ngIf="submitted && f['username'].errors">
                                                                          <p *ngIf="f['username'].errors['required']">
                                                                              Campo obligatorio
                                                                          </p>
                                                                      </div>
                                                                      <div *ngIf="verifyRutCampo">
                                                                          <p>
                                                                              El rut no es válido
                                                                          </p>
                                                                      </div>
                                                                  </div>
                                                              </div>
                                                              <div class="box-campo-input">
                                                                  <app-text Theme="CaptionRegular" Text="N° Dcto Cédula de Identidad" [RadiusLoading]="10" style="color:#0078C8;"></app-text>                                                            
                                                                  <input class="inputt" type="text" formControlName="nDocumento" placeholder="00000000" [ngClass]="{'is-invalid': submitted && f['nDocumento'].errors}" maxlength="9" pKeyFilter="alphanum" (blur)="verifyNDocumento()" />
                                                                  <div class="error">
                                                                      <div *ngIf="submitted && f['nDocumento'].errors">
                                                                          <p *ngIf="f['nDocumento'].errors['required']">
                                                                              Campo obligatorio
                                                                          </p>
                                                                      </div>
                                                                      <div *ngIf="verifyDctoCampo">
                                                                          <p>
                                                                              El número de documento no es válido
                                                                          </p>
                                                                      </div>
                                                                  </div>
                                                              </div>
                                                              <div class="callToAction" *ngIf="!nuevaConsulta">
                                                                <p-button 
                                                                  label="Consultar" 
                                                                  [loading]="loading" 
                                                                  (onClick)="onSubmit()"
                                                                  styleClass="btn-colmena"
                                                                  />
                                                              </div>
                                                              <div body-content class="callToAction" *ngIf="nuevaConsulta">
                                                                  <button tabindex="3" class="btn-submit" type="submit" (click)="refreshPage()">Realizar otra consulta</button>
                                                              </div>
                                                          </form>                                                  
                                                      </div>
                                                  </app-body>
                                              </div>
                                          </app-card>
                                       </div>
                                       <div class="imagen-restitucion">
                                          <img src="./assets/img/life_style_working_01.jpg" />
                                       </div>
                                      
  
                                  </div>
                              </div>
                          </app-body>
                        </div>
                        <div>
                            <div class="box-recaptcha">
                                <div id="recaptcha2"></div>
                            </div>
                        </div>
                      </ng-container>
                        
                    </div>
                    <!-- PLAN DE PAGO -->
                    <div class="tabView" tab-view-content>
                      <ng-container *ngIf="tabView_index == 1">
                        <div>
                          <div class="box-periodos">
                              <app-progress-bar-stepper-periodos-restitucion  [CurrentRutUser]="currentRutUser"></app-progress-bar-stepper-periodos-restitucion>
                          </div>
                      </div>
                      </ng-container>
                    </div>
                    <!-- DEVOLUCION MASIVA -->
                    <div class="tabView" tab-view-content>
                      <ng-container *ngIf="tabView_index == 2">
                        <ng-container *ngIf="viewDevolucionMasiva">
                          <div class="detalle-devolucion-masiva">
                            <div class="grid-double">
                              <app-card Theme="card-primary shadow background-white">
                                <div card-content>
                                  <app-head Theme="head-double-restitucion">
                                    <div head-content class="inline-ico-text">
                                      <div class="head">
                                        <app-text Theme="BodyBold" [Text]="'Devolución Masiva de Excedentes por Restitución'" [RadiusLoading]="10" style="color: #0078c8;"></app-text>
                                      </div>
                                    </div>
                                  </app-head>
                            
                                  <app-body Theme="body-normal">
                                    <div body-content>
                                      <div class="body">
                                        <ul class="list-saldos">
                                          <li>
                                            <div class="box-item">
                                              <div class="saldo">
                                                <h4 >${{devolucionMasivaResp.montoSaldo | number: '1.0-0'}}</h4>
                                                <p>
                                                  *Tu saldo a la fecha indicada
                                                </p>
                                              </div>
                                              <div class="tiempo">
                                                <p>
                                                  Saldo contable al <span>{{devolucionMasivaResp.fechaPostCorteGlosa}}</span>
                                                </p>
                                              </div>
                                            </div>
                                          </li>
                                          <li>
                                            <div class="box-item">
                                              <div class="saldo">
                                                <h4>${{devolucionMasivaResp.montoUsos | number: '1.0-0'}}</h4>
                                                <p>
                                                  *Saldo usado a la fecha
                                                </p>
                                              </div>
                                              <div class="tiempo">
                                                <p>
                                                  Excedentes usados desde <span>{{devolucionMasivaResp.fechaPostCorteGlosa}}</span>
                                                </p>
                                              </div>
                                            </div>
                                          </li>
                                          <li class="saldo-retirar">
                                            <div class="box-item">
                                              <div class="saldo">
                                                <h4>${{devolucionMasivaResp.montoDevolucion | number: '1.0-0' }}</h4>
                                                <p>
                                                  **Saldo que puedes retirar
                                                </p>
                                              </div>
                                              <div class="tiempo">
                                                <p>
                                                  Saldo por pagar al <span>{{devolucionMasivaResp.fechaPagoGlosa}}</span>
                                                </p>
                                              </div>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </app-body>
                                </div>
                              </app-card>
                            
                              <app-card Theme="card-primary shadow background-white">
                                <div card-content>
                                  <app-body Theme="body-normal">
                                    <div body-content>
                                      <div class="right">
                                        <div class="head">
                                          <app-text Theme="BodyBold" [Text]="'Datos bancarios'" [RadiusLoading]="10" style="color: #0078c8;"></app-text>
                                        </div>
                                        <div class="body">
                                          <ul>
                                            <li><p><span>Fecha de Pago:</span> {{devolucionMasivaResp.fechaPago}}</p></li>
                                            <li>
                                              <p>
                                                <span>Tipo de Pago:</span>
                                                <ng-container *ngIf="devolucionMasivaResp.tipoPagoGlosa != ''">
                                                  {{devolucionMasivaResp.tipoPagoGlosa}}
                                                </ng-container>
                                                <ng-container *ngIf="devolucionMasivaResp.tipoPagoGlosa === ' '">
                                                  -
                                                </ng-container>
                                              </p>
                                            </li>
                                            <li><p><span>Banco:</span> 
                                              <ng-container *ngIf="devolucionMasivaResp.bancoPago != ''">
                                                {{devolucionMasivaResp.bancoPago}}
                                              </ng-container>
                                              <ng-container *ngIf="devolucionMasivaResp.bancoPago === ' '">
                                                -
                                              </ng-container>
                                              
                                            
                                            </p></li>
                                            <li>
                                              <p *ngIf="devolucionMasivaResp['cuenta'] != null && devolucionMasivaResp['fechaVencimientoValeVista'] === null ">
                                                <span>Cuenta:</span>
                                                {{devolucionMasivaResp.numeroCuenta}}
                                              </p>
                                              <p *ngIf="infoRetiro['cuenta'] === null && devolucionMasivaResp['fechaVencimientoValeVista'] != null ">
                                                <span>Vencimiento Vale Vista:</span>
                                                {{devolucionMasivaResp['fechaVencimientoValeVista']}}
                                              </p>
                                      
                                            </li>
                                      
                                            <li><p><span>Estado de Pago:</span> {{devolucionMasivaResp.estadoPagoGlosa}}</p></li>
                                      
                                            <li *ngIf="!detalleVencimiento"><p><span>Fecha vencimiento Vale Vista:</span> {{devolucionMasivaResp.fechaVencimientoValeVista}}</p></li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </app-body>
                                </div>
                              </app-card>
                            </div>
                          </div>
                        </ng-container>
                        
                      </ng-container>  
                    </div>
                    <!-- DETALLE DE MOVIMIENTOS -->
                    <div class="tabView" tab-view-content>
                      <ng-container *ngIf="tabView_index == 3">
                        <ng-container>
                          <div class="results">
                            <h3>Resumen de Movimientos (Apertura {{resumenCta.fechaAperturaFormat}})</h3>
                            <div class="box-tabla-restitucion">
                              <p-table [value]="resumenMovimientosRest.listaMovimientos" styleClass="tabla-restitucion">
                                <ng-template pTemplate="header" let-columns>
                                  <tr>
                                    <th>Movimientos</th>
                                    <th>Saldos</th>
                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                  <tr>
                                      <td class="ui-resizable-column"> {{rowData?.glosaMovimiento | titlecase}}</td>
                                      <td class="ui-resizable-column text-right">$ {{rowData?.abonos - rowData?.cargos |  number:'1.0-0'}}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                  <tr>
                                      <td>Sin movimientos</td>
                                  </tr>
                              </ng-template>
                              </p-table>
                            </div>
                          </div> 
                          <br><br>
                          <div class="box-callToAction">
                            <ul>
                                <!-- <li>
                                    <button tabindex="3" class="btn-volver" type="submit" (click)="backClicked()">Volver</button>
                                </li> -->
                                <li class="siguiente" *ngIf="excedente">
                                    <button tabindex="3" class="btn-submit" type="submit" (click)="verDetalleMovimientos()">Ver detalle de movimientos</button>
                                </li>
                            </ul>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="viewDetalle">
                        <br><br>
                        <app-detalle-de-movimientos [RutUser]="formData.controls['username'].value"></app-detalle-de-movimientos>
                      </ng-container>
                      </ng-container>
                    </div>
                    <div  class="tabView" tab-view-content>
                      <ng-container  *ngIf="tabView_index == 4">
                        <app-cartola-de-movimientos [CurrentRutUser]="currentRutUser" [TypeApp]="typeApp"></app-cartola-de-movimientos>
                      </ng-container>
                    </div>

                    <!-- PRONTO PAGO -->
                    <div class="tabView" tab-view-content>
                      <ng-container *ngIf="tabView_index == 5">
                        <app-pronto-pago
                          [pasoInicial]="pasoInicialProntoPago"
                          (salir)="volverDesdeProntoPago()">
                        </app-pronto-pago>
                      </ng-container>
                    </div>

                </app-tab-view>
            </div>
        </div>

    </app-card>
</div>